export var COUPONS_LIST_PATH = '/coupons/';
export var COUPONS_CREATE_PATH = "".concat(COUPONS_LIST_PATH, "create/");
export var COUPONS_EDIT_PATH = "".concat(COUPONS_LIST_PATH, ":id/modify");
export var getCouponEditPath = function getCouponEditPath(id) {
    return "".concat(COUPONS_LIST_PATH).concat(id, "/modify");
};
